import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import PrivateNavBar from '../nav-bar/PrivateNavBar'
import PrivateFooter from '../footer/PrivateFooter'
import Explore from '../explore/Explore'
import Home from '../home/Home'
import { Switch, Route, Redirect } from 'react-router-dom'
import SearchResult from '../search-result/SearchResult'

import Users from '../users/Users'
// import BunkeyBotPrivate from '../bunkey-bot/BunkeyBotPrivate'
import ListPermission from '../permission/ListPermission'
import ConfirmAssets from '../confirmation/ConfirmAssets'
import ListClient from '../create-client/ListClient'
import Reports from '../reports/Reports'
import EyeOfSauron from '../eye-of-sauron/EyeOfSauron'
import MasiveUploadClient from '../masive-upload-client/MasiveUploadClient'
import './bootstrap.min.css'
import './flickity.css'
import './privateSite.css'
// import BunkeyNotification from '../bunkey-notification/BunkeyNotification'
import Dashboard from "../dashboard/Dashboard";
import ActivityLog from "../activity-log/ActivityLog";
import PlanDetail from "../dashboard/plan-detail/PlanDetail";
import TrashDetail from "../dashboard/trash-detail/TrashDetail";
import RightsManager from "../rights-manager/RightsManager";
import ScrollToTop from "../../utils/ScrollToTop";
import MultiSelectorHeaderOptions from "../multi-selector-header-options/MultiSelectorHeaderOptions";

export class PrivateSite extends Component {

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleOnbeforeunload)
  }

  handleOnbeforeunload = event => {
    const { isUploading } = this.props
    if (isUploading) event.returnValue = isUploading
  }

  render() {

    const { user } = this.props
    // La papelera es sólo de administradores (de cuenta o de workspace).
    const isAdmin = !!user && (user.role === 'admin' || user.clientRole === 'admin')

    return (
      <div className="private-site-layout">
        <MultiSelectorHeaderOptions />
        <PrivateNavBar />
        <main className="private-site-content">
          <ScrollToTop>
          <Switch>
            <Route exact path={`${this.props.match.url}`} component={Home} />
            <Route exact path={`${this.props.match.url}/dashboard`} component={Dashboard} />
            <Route exact path={`${this.props.match.url}/activity-log`} component={ActivityLog} />
            <Route exact path={`${this.props.match.url}/groups/:id?`} component={ListPermission} />
            <Route exact path={`${this.props.match.url}/explore/:folder`} component={Explore} />
            <Route exact path={`${this.props.match.url}/users/`} component={Users} />
            <Route exact path={`${this.props.match.url}/clients/`} component={ListClient} />
            <Route exact path={`${this.props.match.url}/confirm`} component={ConfirmAssets} />
            <Route exact path={`${this.props.match.url}/result`} component={SearchResult} />
            <Route exact path={`${this.props.match.url}/reports`} component={Reports} />
            <Route exact path={`${this.props.match.url}/eye-of-sauron`} component={EyeOfSauron} />
            <Route exact path={`${this.props.match.url}/masive-upload-client`} component={MasiveUploadClient} />
            <Route exact path={`${this.props.match.url}/plan-detail`} component={PlanDetail} />
            {/* El ítem del menú ya estaba oculto para operadores, pero la ruta se
                alcanzaba escribiendo la URL a mano. */}
            <Route
              exact
              path={`${this.props.match.url}/trash`}
              render={props => isAdmin
                ? <TrashDetail {...props} />
                : <Redirect to={this.props.match.url} />}
            />
            <Route exact path={`${this.props.match.url}/rights`} component={RightsManager} />
          </Switch>
          </ScrollToTop>
        </main>
        {/* <BunkeyBotPrivate /> */}
        {/* <BunkeyNotification /> */}
        <PrivateFooter />
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    isUploading: state.client.isUploading,
  }
}

const mapDispatchToProps = {}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateSite)))
